import { render, staticRenderFns } from "./ScreenshotCarousel.vue?vue&type=template&id=7ccbd500&"
import script from "./ScreenshotCarousel.vue?vue&type=script&lang=ts&"
export * from "./ScreenshotCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./ScreenshotCarousel.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCarousel,QCarouselSlide});
